module.exports = __webpack_public_path__ + "static/img/app.53ad57f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contactus/app.png
// module id = A6oT
// module chunks = 51